import UserCreate from '_modules/user/views/UserCreate.vue';
import UserEdit from '_modules/user/views/UserEdit.vue';
import UserList from '_modules/user/views/UserList.vue';
import User from './Root.vue';
import moduleMiddleware from '../../../router/middlewares/moduleMiddleware';


export default {
  path: 'usuarios/',
  component: User,
  beforeEnter: moduleMiddleware('users'),
  name: 'admin-user',
  redirect: '/usuarios/lista/1',
  children: [
    {
      path: 'lista/:page',
      name: 'admin-user-list',
      component: UserList,
    },
    {
      path: 'novo/',
      name: 'admin-user-new',
      component: UserCreate,
    },
    {
      path: ':userId',
      name: 'admin-user-edit',
      component: UserEdit,
    },
  ],
};
